import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../../../CloudStorage/LoadCSSforfirstTime";
import DashboardPieChart from "../../../../../CustomComponents/DashboardPieChart";
import DashboardHorizontalChart from "../../../../../CustomComponents/DashboardHorizontalChart";
import { useDispatch, useSelector } from "react-redux";
import { getUmbrallaPostsById } from "../../../../../../redux/umbrella/action";
import { useNavigate, useParams } from "react-router-dom";
import ChildUmbrellaProjectListing from "./ChildUmbrellaProjectListing";
import { getPercentage } from "../../../../../Common/FewCommonMethods";
import CustomeCircularProgressbar from "../../../../../Common/CustomeLabel/CustomeCircularProgressbar";
import ProfilePic from "../../../../../../assests/imgs/Profileplaceholder.svg";

export default function UmrellaProjectDetails() {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [showAll, setShowAll] = useState(false);

  const path = "Assets/scss/umbrella.module.scss";
  const { id } = useParams();

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const upd = useSelector(
    ({ umbrella: { umbrallapostbyid } }) => umbrallapostbyid,
  );

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUmbrallaPostsById(id));
  }, [id]);
  const navigate = useNavigate();

  const handleToggle = () => {
    setShowAll(!showAll);
  };
  const percentage = getPercentage(
    upd?.total_milestone,
    upd?.completed_milestone,
  );

  const totalamount =
    (Number(upd?.total_paid) || 0) +
    (Number(upd?.total_escrow) || 0) +
    (Number(upd?.total_pending) || 0);

  const DashboardPieChartdata = {
    total_paid: Number(upd?.total_paid) || 0,
    total_escrow: Number(upd?.total_escrow) || 0,
    total_pending: Number(upd?.total_pending) || 0,
  };


  return (
    <div>
      <div className="umbrellaproject">
        <p className="breadcrumbs">
          <a
            onClick={() => {
              navigate(-1);
            }}
          >
            My orders &gt;
          </a>
          {upd?.ambrella_title}
        </p>
        <div className="umbrella-first">
          <h2>Project insights</h2>
          <div className="row dashboard-row">
            <div className="col-md-4 earning">
              <div className="earning-wrapper">
                <div className="earn-head">
                  <h2>Project cost</h2>
                  <div className="graph-label">
                    <p>
                      <span className="paid"></span>Paid
                    </p>
                    <p>
                      <span className="escrow"></span>Escrow
                    </p>
                    <p>
                      <span className="pending"></span>Pending
                    </p>
                  </div>
                </div>
                <div className="graph-sec graph-first-sec" >
                  <h4>Total Cost</h4>
                  <h3>$ {totalamount}</h3>
                  <DashboardPieChart dashboarddata={DashboardPieChartdata} />
                </div>
              </div>
            </div>
            <div className="col-md-4 earning">
              <div className="earning-wrapper">
                <div className="earn-head d-block text-center">
                  <h2>Project progress</h2>
                  <p className="text-center">
                    {upd?.completed_milestone} out of {upd?.total_milestone} {' '}
                    milestones completed
                  </p>
                </div>
                <div className="col-md-6 mx-auto col-6 ">
                  <CustomeCircularProgressbar percentage={percentage} />
                </div>
              </div>
            </div>
            <div className="col-md-4 earning">
              <div className="earning-wrapper">
                <div className="earn-head">
                  <h2>Post & Browse Projects (PBP) </h2>
                </div>
                <div className="project-sec">
                  <div className="project-wrapper">
                    <div className="project-img">
                      <span>
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/bag.svg`}
                          alt=""
                        />
                      </span>
                      <p>Posted sub projects</p>
                    </div>
                    <h4>{upd?.posted_sub_projects || 0}</h4>
                  </div>
                  <div className="project-wrapper">
                    <div className="project-img">
                      <span>
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/bag.svg`}
                          alt=""
                        />
                      </span>
                      <p>Active sub projects</p>
                    </div>
                    <h4>{upd?.active_sub_projects || 0}</h4>
                  </div>
                  <div className="project-wrapper">
                    <div className="project-img">
                      <span>
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/bag.svg`}
                          alt=""
                        />
                      </span>
                      <p>Completed sub projects</p>
                    </div>
                    <h4>{upd?.completed_sub_projects || 0}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-8">
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between'
              }}>
                <h4>Current tasks</h4>
                <button className="buttons background-button" style={{ borderWidth: 1 }}
                  onClick={() => {
                    navigate(`/${lan}/account/calendar`)
                  }}
                >View calendar</button>
              </div>
              <DashboardHorizontalChart milestones={upd?.milestones} />
            </div>
            <div className="col-md-4 earning">
              <div className="earning-wrapper">
                <div className="sar">
                  <h4>Hired Experts</h4>
                  <p>Experts working on this project</p>
                </div>
                <div className="row hired-img-row">
                  {(Array.isArray(upd?.experts) && upd?.experts?.length > 0) ?
                    (
                      <>
                        {showAll
                          ? upd?.experts?.map((item, index) => (
                            <div className="col-md-6" key={index}>
                              <div className="hired-img">
                                <img
                                  src={item?.profile_image ? item?.profile_image : ProfilePic}
                                  className="profile-img"
                                  alt=""
                                />
                                <p>
                                  {item?.first_name} {item?.last_name}
                                </p>
                              </div>
                            </div>
                          ))
                          : upd?.experts.slice(0, 3).map((item, index) => (
                            <div className="col-md-6" key={index}>
                              <div className="hired-img">
                                <img
                                  src={item?.profile_image ? item?.profile_image : ProfilePic}
                                  className="profile-img"
                                  alt=""
                                />
                                <p>
                                  {item?.first_name} {item?.last_name}
                                </p>
                              </div>
                            </div>
                          ))}
                        {!showAll && upd?.experts?.length > 3 && (
                          <div className="col-md-6">
                            <div className="hired-img">
                              <span>+{upd?.experts?.length - 3}</span>
                            </div>
                          </div>
                        )}
                      </>
                    ) :
                    <>
                      <div className="col-md-12" >
                        <p>No Experts available</p>
                      </div>

                    </>
                  }
                  {upd?.experts?.length > 3 && (
                    <button className="btn withdraw" onClick={handleToggle}>
                      {showAll ? "Show Less" : "View All"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ChildUmbrellaProjectListing umbrellaprojectdetails={upd} />
      </div>
    </div>
  );
}
